import React from "react";

const Footer = () => (
  <div className="appFooter">
    <div>&copy; Pheirce Bytes, LLC. All rights reserved.</div>
    <div>
      Love this? Let's build something delightful together.{" "}
      <a href="mailto:hello@pheircebytes.com">hello@pheircebytes.com</a>
    </div>
  </div>
);

export default Footer;
